/*Purpose: GetQuoteModal is a pop up that asks the user for an email address. 
            The user can then click get quote which invokes the lambda____________
            This sends an email to a Windsor Lending admin with the request for a quote and the email entered.
    Props:
    Author: R. Markowitz June 2026
    Dev notes:
*/

import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { validateField, emailRegex, emailInvalidMsg, nameRegex, nameInvalidMsg, phoneRegex, phoneInvalidMsg, creditScoreRegex, creditScoreInvalidMsg, addressRegex, addressInvalidMsg } from "../Data/Regex";

const GetQuoteModal = (props) => {
    const show = props.show
    const handleClose = props.handleClose

    // This invokes the send quote email lambda and closes the modal
    const sendQuoteEmail = async() => {
        
        const guestEmail = document.getElementById("guestEmail").value;
        const name = document.getElementById("name").value;
        const phone = document.getElementById("phone").value;
        const creditScore = document.getElementById("creditScore").value;
        const propertyAddress = document.getElementById("propertyAddress").value;

        let msg;
        
        if (!validateField({"value": guestEmail, "regex": emailRegex})){
            alert(emailInvalidMsg)
        }else if(!validateField({"value": name, "regex": nameRegex})){
            alert(nameInvalidMsg)
        }else if(!validateField({"value": phone, "regex": phoneRegex})){
            alert(phoneInvalidMsg)
        }else if(!validateField({"value": creditScore, "regex": creditScoreRegex})){
            alert(creditScoreInvalidMsg)
        }else if(!validateField({"value": propertyAddress, "regex": addressRegex})){
            alert(addressInvalidMsg)
        }else{
            console.log("Send email to steven@windsorlending.net that " + guestEmail + " wants a quote. \nDetails-----\nName: " + name +"\nPhone: " + phone + "\nCreditScore: " + creditScore + "\nPropertyAddress: " + propertyAddress)
            
            // Send email to windsor lending team with provided details.
            try{
                const response = await fetch("https://f0ll5x1c4l.execute-api.us-east-1.amazonaws.com/sendQuoteRequest", {
                    "method": "POST",
                    "body": JSON.stringify({
                        "Name": name,
                        "Email": guestEmail,
                        "Phone": phone,
                        "CreditScore": creditScore,
                        "PropertyAddress": propertyAddress
                    })
                })

                if(response.ok){
                    msg = await response.json();

                }else{
                    let error = response.statusText
                    if (response.status == 400){
                        error = await response.json();
                    }
                    msg = "There was an error sending the quote request. Please try again. If the problem persists, please contact info@windsorlending.net.";
                    console.log(error)
                }
            }catch (e){
                msg = "There was an error sending the quote request. Please try again. If the problem persists, please contact info@windsorlending.net.";
                console.log(e)
            }
            alert(msg)
            handleClose()
        }
        

        
    }
    return(
        <Modal show = {show} onHide = {handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Get a Quote</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId = "name">
                        <Form.Label>First and Last Name:</Form.Label>
                        <Form.Control type = "text" placeholder = "Name"></Form.Control>
                    </Form.Group>

                    <Form.Group controlId = "guestEmail">
                        <Form.Label>Email:</Form.Label>
                        <Form.Control type = "email" placeholder = "name@example.com"></Form.Control>
                    </Form.Group>

                    <Form.Group controlId = "phone">
                        <Form.Label>Phone Number:</Form.Label>
                        <Form.Control type = "text"></Form.Control>
                    </Form.Group>

                    <Form.Group controlId = "creditScore">
                        <Form.Label>Credit Score:</Form.Label>
                        <Form.Control type = "text" placeholder = "0"></Form.Control>
                    </Form.Group>

                    <Form.Group controlId = "propertyAddress">
                        <Form.Label>Property Address:</Form.Label>
                        <Form.Control type = "text" placeholder = "Property Address"></Form.Control>
                    </Form.Group>

                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant = "secondary" onClick = {handleClose}>Cancel</Button>
                <Button variant = "primary" onClick = {sendQuoteEmail}>Get Quote</Button>
            </Modal.Footer>

        </Modal>
    );

}

export default GetQuoteModal;
